import { useState } from 'react';
import { Check } from 'lucide-react';
import type { JobCategory } from '../types';

interface CategorySelectorProps {
  categories: JobCategory[];
  selectedCategory: string;
  onSelect: (categoryId: string) => void;
  error?: string;
}

const CategorySelector = ({ categories, selectedCategory, onSelect, error }: CategorySelectorProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedCategoryData = categories.find(cat => cat.id === selectedCategory);

  return (
    <div className="mt-1">
      <div className="relative">
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className={`w-full bg-navy border rounded-lg px-3 py-2 text-left flex items-center justify-between ${
            error ? 'border-red-500' : 'border-tan-dark'
          } ${selectedCategory ? 'text-tan' : 'text-tan-dark'}`}
        >
          <div className="flex items-center gap-2">
            {selectedCategoryData ? (
              <>
                <span>{selectedCategoryData.icon}</span>
                <span>{selectedCategoryData.name}</span>
              </>
            ) : (
              <span>Select a category...</span>
            )}
          </div>
          <svg
            className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {isOpen && (
          <div className="absolute z-10 w-full mt-1 bg-navy border border-tan-dark rounded-lg shadow-lg max-h-60 overflow-auto">
            {categories.map((category) => (
              <button
                key={category.id}
                type="button"
                onClick={() => {
                  onSelect(category.id);
                  setIsOpen(false);
                }}
                className="w-full px-3 py-2 text-left hover:bg-navy-light flex items-center justify-between group"
              >
                <div className="flex items-center gap-2">
                  <span className="text-lg">{category.icon}</span>
                  <div>
                    <div className="text-tan font-medium">{category.name}</div>
                    <div className="text-tan-dark text-xs">{category.description}</div>
                  </div>
                </div>
                {selectedCategory === category.id && (
                  <Check className="text-tan" size={16} />
                )}
              </button>
            ))}
          </div>
        )}
      </div>

      {error && (
        <p className="text-red-400 text-xs mt-1">{error}</p>
      )}
    </div>
  );
};

export default CategorySelector;